import { toRequest } from 'react-async-client';

import { SESSION_OVER_LOGOUT, LOGIN } from 'constants/actionTypes';

export const sessionOverReducer = (state = false, action) => {
    switch(action.type) {
        case SESSION_OVER_LOGOUT:
            return true;
        case toRequest(LOGIN):
            return false;
        default:
            return state;
    }
};
